import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_JOB_ORDER_GET_BY_ID } from 'api/actionTypes';

export default async function getById({ state, apiClient }, { jobOrderId, reload }) {
  typeCheck('jobOrderId::PositiveNumber', jobOrderId);

  const statePath = ['jobOrders', 'byId', jobOrderId];

  if (!reload && state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_JOB_ORDER_GET_BY_ID,
    state: state,
    payload: {
      jobOrderId,
    },
    onSuccess(jobOrder) {
      state.set(statePath, jobOrder);
      return jobOrder;
    },
  });
}
